export const GLOBALS = {
  font: {
    default: { family: "'Open Sans', sans-serif" },
    title: { family: "'Bitter', serif", weight: 400, size: '24px', lineHeight: '50px', color: 'black' }
  },
  color: {
    grey: {
      '500': '#5C5C5C',
      '600': '#C9C9C9'
    },
    turquoise: {
      '400': '#19b0ad',
      '500': '#1AB8B6'
    }
  },
  transition: {
    default: { duration: '0.2s' }
  }
} as const
